import { render, staticRenderFns } from "./CadProdutorFazenda.vue?vue&type=template&id=146a564c"
import script from "./CadProdutorFazenda.vue?vue&type=script&lang=js"
export * from "./CadProdutorFazenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports